import { render, staticRenderFns } from "./tradeTerm.vue?vue&type=template&id=211ae17b&"
import script from "./tradeTerm.vue?vue&type=script&lang=js&"
export * from "./tradeTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('211ae17b')) {
      api.createRecord('211ae17b', component.options)
    } else {
      api.reload('211ae17b', component.options)
    }
    module.hot.accept("./tradeTerm.vue?vue&type=template&id=211ae17b&", function () {
      api.rerender('211ae17b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/tradeTerm.vue"
export default component.exports